// Canal del wizard al que pertenece el paso de conexión.
export const WHATSAPP_CHANNEL_NAME = 'whatsapp';
// Caminos del paso 2 del alta de WhatsApp Cloud (?path=): asistido con Facebook o manual.
export const EMBEDDED_PATH = 'embedded';
export const MANUAL_PATH = 'manual';
export const CONNECT_PATHS = [EMBEDDED_PATH, MANUAL_PATH];
// Rutas del wizard que intervienen en el alta de WhatsApp Cloud.
export const INBOX_CHANNEL_FORM_ROUTE = 'settings_inboxes_page_channel';
export const WHATSAPP_CONNECT_ROUTE = 'settings_inbox_whatsapp_connect';

// El paso 2 solo tiene sentido con un camino elegido en la query; sin él (URL escrita a mano,
// marcador, recarga con la query perdida) se regresa al selector antes de renderizar nada y
// sin dejar la URL inválida en el historial.
export default function whatsappConnectGuard(to, from, next) {
  if (CONNECT_PATHS.includes(to.query.path)) {
    next();
    return;
  }

  next({
    name: INBOX_CHANNEL_FORM_ROUTE,
    params: { page: 'new', sub_page: WHATSAPP_CHANNEL_NAME },
    replace: true,
  });
}
